const Section = ({ children }) => {
  return (
    <section className="text-xl font-interSemiBold text-codiDarkGray bg-white rounded-large p-6">
      {children}
    </section>
  );
};

export default Section;
